module.exports = __webpack_public_path__ + "static/media/login_full_bg0.daca8a79.jpg";